<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-tab-section-bottom auto-qa-home-bottom panel-bottom-flex">
    <div class="chart-legend">
      <div class="legend-flex" @click="toggleLegend(item)" v-for="(item, index) in legendsData" :key="index">
        <div :class="{'line-marker': true, 'grey-out':!item.toggle}" :style="{'background-color': item.color}">
        </div>
        <div class="legend-name" :class="(!item.toggle?'grey-out':'')" >{{item.legend}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
    name: 'wy-panel-tab-section-bottom',
    props: ['controller', 'legendData', 'sectionData', 'parent'],
    data() {
      return {
        legendsData: []
      }
    },
    computed: {
    ...mapGetters(['legendColors']),
    },
    methods: {
      renderLegends() {
        this.legendsData = [];
          this.legendData['legends'].forEach((item, index) => {
            let obj = {};
            obj.legend = item;
            obj.toggle = true;
            if(Array.isArray(this.sectionData)) {
              obj.color = this.sectionData[0].lineChartData.legendColors[index];
            }
            this.legendsData.push(obj);
          });
        if(!Array.isArray(this.sectionData)) {
          let obj = {};
          obj.legend = 'regression';
          obj.color = '0C2837';
          obj.toggle = true;
          this.legendsData.push(obj);
        }
      },
      toggleLegend(item) {
        if(this.sectionData) { 
          if(this.parent.$refs.lineChart) {
            let toggleCount = 0;
            this.legendsData.forEach((legend, index) => {
              if(index < this.legendsData.length) {
                if(legend.toggle) {
                  toggleCount = toggleCount + 1
                }
              }
            })
            if(item.legend == 'regression' || toggleCount > 1 || !item.toggle) {
              item.toggle = !item.toggle;
              this.parent.$refs.lineChart.toggleLegend(item.legend, item.toggle)
            }
          }
        }
      }
    }
  }); 
</script>

<style lang="scss">
  .wy-panel-tab-section-bottom.auto-qa-home-bottom.panel-bottom-flex {
    border-top: 1px #CAD2DA solid;
    height: 38px;
    // height: 75px;
    display: flex;
    align-items: center;
    align-items: center;
    margin-bottom: 2px;

    .legend-marker {
      cursor: pointer;
      border-radius: 50%;
      width: 10px;
      height: 10px;
    }
    .regression-marker{
      cursor: pointer;
      margin:5px 5px;
      height:2px;
      width: 25px;
      background-color: unset !important;
      background:repeating-linear-gradient(to right,black 0,black 5px,transparent 5px,transparent 7px)
    }
    .line-marker{
      cursor: pointer;
      margin:5px 5px;
      position: relative;
      top: 3px;
      height:2px;
      width: 25px;
    }
    .chart-legend{
      display: flex;
      width: 89%;
      height: 50px;
      overflow-y: hidden;
      position: relative;
      left: 38px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }
    .legend-flex {
      display: flex;
      height: 25px;
      -webkit-box-align: center;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .legend-marker {
      margin: 5px;
    }
    .legend-marker.grey-out {
      opacity: 0.3;
    }
    .regression-marker.grey-out {
      opacity: 0.3;
    }
    .legend-name {
      position: relative;
      cursor: pointer;
      font-size: 14.22px;
      color: var(--site-font-tertiary-color);
      font-weight:400;
      line-height: 1;
      top: 3px;
    }
    .legend-name.grey-out {
      color: #CCC;
    }
    .line-marker.grey-out {
      opacity: 0.5;
    }
  }
</style>
